var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 px-3",attrs:{"fluid":""}},[_c('div',{staticStyle:{"position":"sticky","top":"0","z-index":"20","background":"#ffffff","padding":"0"}},[_c('h2',{staticClass:"pt-3 pb-2",staticStyle:{"letter-spacing":"normal"}},[_vm._v("My Schedule")])]),_c('app-my-schedule')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }